import { Component, computed } from '@angular/core';
import {
  ACTION_DATA_TEMPLATE,
  ActionComponent,
} from '@kinet-open-network/client/automations/feature/builder';
import {
  datepicker,
  DynamicFormField,
  formBuilder,
} from '@kinet-open-network/client/core/forms/ui';
import { IAutomationActionRegenerateOrderStockMovesData } from '@kinet-open-network/shared/data-access/model-pbgas';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'kon-regenerate-order-stock-moves-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class RegenerateOrderStockMovesActionComponent extends ActionComponent<'regenerate-order-stock-moves'> {
  // The dates apply to the global context only; in the order context the action runs for that order.
  override fields = computed<DynamicFormField[]>(() =>
    formBuilder([
      datepicker('fromDate', 'Dátum objednávky od'),
      datepicker('toDate', 'Dátum objednávky do'),
    ]),
  );

  override dataToModel(
    data: Partial<IAutomationActionRegenerateOrderStockMovesData>,
  ) {
    return {
      fromDate: data.fromDate ? new Date(data.fromDate) : undefined,
      toDate: data.toDate ? new Date(data.toDate) : undefined,
    };
  }
}
